<template>
  <div id="app">
    <the-navbar/>
    <router-view></router-view>
    <the-footer/>
    <div style="height: 150px;"></div>
  </div>
</template>

<script>
import TheNavbar from '@/components/singleton/TheNavbar'
import TheFooter from '@/components/singleton/TheFooter'

export default {
  name: 'App',
  components: {TheNavbar, TheFooter},
  mounted: function () {
    this.$store.dispatch('fetchProducts')
    this.$store.dispatch('fetchDeliveryInfo')
  }
}
</script>

<style>
</style>
